import CommonImage from '@/components/CommonImage';

const SearchTypeDropdown = () => {
	return (
		<div className="edit-items search-edit-items">
			<div className="option">
				<div className="dropdown">
					<button
						className="btn btn-default dropdown-toggle d-flex align-items-center gap-2"
						type="button"
						data-toggle="dropdown"
					>
						<CommonImage src="/icons/search-dark.svg" />
					</button>
				</div>
			</div>
		</div>
	);
};

export default SearchTypeDropdown;
